module.exports = __webpack_public_path__ + "static/media/landing-mockup.61d865a3.png";